export default "__VITE_ASSET__Bh5ZaJkI__"